export default {
  'success.title': '支付完成',
  'success.message': '您的付款已成功，请商户确认。',
  'success.closeBtn': '关闭页面',
  'error.title': '提示',
  'error.scanToEnter': '请重新扫码进入！',
  'oauth.redirecting': '正在跳转...',
  'index.welcome': '欢迎使用收银台',
  'index.scanHint1': '请使用手机',
  'index.scanHint2': '扫描收款码进入',
  'pay.headerPayTo': '付款给',
  'pay.amountPlaceholder': '请输入日元金额',
  'pay.alipayPlus': 'Alipay+支付',
  'pay.wxpay': '微信支付',
  'pay.remarkEdit': '修改',
  'pay.remarkAdd': '添加备注',
  'pay.payButton': '付款',
  'pay.alertSuccess': '支付成功！',
  'pay.alertCancelled': '支付取消',
  'pay.alertFailed': '支付失败:',
  'pay.alertMissingParam': '缺少参数',
  'dialog.title': '添加备注',
  'dialog.placeholder': '最多输入12个字',
  'dialog.cancel': '取消',
  'dialog.confirm': '确认',
  'http.requestFailed': '请求失败，请稍后重试',
  'main.scanOnly': '请通过二维码进入支付页面！',
  'main.walletOnly': '请用微信或Alipay+钱包内扫码进入！'
}
